import React, { useState, useContext } from "react";
import { List, Collapse, Divider } from "antd";
import { isMobile } from "react-device-detect";
import { UserContext } from "../../UserContext";
import {
  findToUserName,
  findFromUserName,
  findReturnedByUserName,
  findDeletedByUserName,
} from "../../helpers/index";
import { SwipeableList, SwipeableListItem } from "react-swipeable-list";
import { CheckCircleFilled, CheckCircleOutlined } from "@ant-design/icons";
import dayjs from "../../utils/dayjs";

const LendsList = ({
  data,
  allUsersInFirebase,
  trailingActions,
  leadingActions,
  formatUser,
  showLeadingActions,
  showTrailingActions,
}) => {
  const { Panel } = Collapse;
  const { user } = useContext(UserContext);
  const [openKey, setOpenKey] = useState([]);
  const { numberOfColumns } = user || {};

  const handleCollapseChange = (key) => {
    const isOpen = openKey.includes(key);

    isOpen && setOpenKey(openKey.filter((item) => item !== key));
    !isOpen && setOpenKey([...openKey, key]);
  };

  const ItemStatus = (item) => {
    const isDeleted = !!item?.deleted;

    if (isDeleted) {
      return (
        <CheckCircleFilled
          style={{
            color: "red",
            fontSize: "15px",
            display: "block",
          }}
        />
      );
    }

    if (item.returnedBy !== null) {
      if (item.returned === true) {
        return (
          <CheckCircleFilled
            style={{
              color: "#ff7043",
              fontSize: "15px",
              display: "block",
            }}
          />
        );
      }
      if (item.returned === false) {
        return (
          <CheckCircleOutlined
            style={{
              color: "#ff7043",
              fontSize: "15px",
              display: "block",
            }}
          />
        );
      }
    }

    return (
      <CheckCircleOutlined
        style={{
          color: "#d9d9d9", // Color gris para no regresados
          fontSize: "13px",
          display: "block",
        }}
      />
    );
  };
  return (
    <List
      grid={{ gutter: 16, column: isMobile ? numberOfColumns : 4 }}
      dataSource={data}
      renderItem={(item) => {
        const { id } = item;
        return (
          <List.Item>
            <SwipeableList fullSwipe={true}>
              <SwipeableListItem
                key={id}
                blockSwipe={false}
                trailingActions={showTrailingActions ?? trailingActions(item)}
                leadingActions={showLeadingActions ?? leadingActions(item)}
              >
                <Collapse
                  activeKey={openKey.includes(id) ? id : []}
                  onChange={() => handleCollapseChange(id)}
                  style={{
                    width: "100%",
                    margin: "0 !important",
                    padding: "0 !important",
                  }}
                  expandIcon={() => ItemStatus(item)}
                >
                  <Panel
                    key={id}
                    header={
                      <div>
                        <span
                          style={{
                            color: item.returned ? "#ff7043" : "#1890ff",
                            display: "flex",
                            justifyContent: "start",
                          }}
                        >
                          {openKey.includes(id) &&
                            !!item.returnedBy &&
                            findReturnedByUserName(item, allUsersInFirebase)}
                        </span>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{item.name}</span>
                          <span
                            style={{
                              color: "red",
                              display: "flex",
                              justifyContent: "start",
                            }}
                          >
                            {item.deletedBy &&
                              findDeletedByUserName(item, allUsersInFirebase)}
                          </span>
                        </div>
                        <Divider
                          style={{
                            margin: "3px",
                            borderWidth: "1px",
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <span
                            style={{
                              color: "#1890ff",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <span>[{item.quantity.toString().trim()}]</span>
                          </span>
                          <span
                            style={{
                              color: "#1890ff",
                              display: "flex",
                              justifyContent: isMobile ? "start" : "center",
                              alignContent: "center",
                            }}
                          >
                            {item.toCompany}
                          </span>
                        </div>
                      </div>
                    }
                  >
                    {/* Contenido del Panel */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: isMobile
                          ? "1fr"
                          : "repeat(2, 1fr)", // Una columna en móvil, tres en escritorio
                        gap: "8px", // Espacio entre los elementos
                      }}
                    >
                      {[
                        {
                          label: "Recibe:",
                          value: findToUserName(item, allUsersInFirebase),
                        },
                        {
                          label: "Anota:",
                          value: findFromUserName(item, allUsersInFirebase),
                        },
                        {
                          label: "Fecha de préstamo:",
                          value: dayjs(item.date, "DD-MM-YYYY HH:mm:ss").format(
                            "DD/MMMM"
                          ),
                        },
                        {
                          label: "Hora de préstamo:",
                          value: dayjs(
                            item.date,
                            "DD-MM-YYYY HH:mm:ss"
                          ).format("HH:mm"),
                        },
                      ].map((entry, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px", // Espacio entre la etiqueta y el valor
                            marginBottom: isMobile ? "8px" : "0", // Margen inferior en vista móvil
                          }}
                        >
                          <strong>{entry.label}</strong> {entry.value}
                        </div>
                      ))}
                    </div>
                    <div>
                      {item.comment && <strong> Historial de cambios: </strong>}
                      {item.comment?.split("\n").map((line, index) => (
                        <p
                          style={{
                            margin: "0px",
                            marginBottom: "7px",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                            textAlign: "left",
                          }}
                          key={index}
                        >
                          {line}
                        </p>
                      ))}
                    </div>
                  </Panel>
                </Collapse>
              </SwipeableListItem>
            </SwipeableList>
          </List.Item>
        );
      }}
    />
  );
};
export default LendsList;
